<div class="flex items-center justify-center dialog-header ">
    {{title}}

    <div class="absolute right-2">
        <button
            (click)="handleCloseNoteDialog()"
            class="outline-none p-5"
        >
            <i class="pi pi-times"></i>
        </button>
    </div>

</div>
<div class="dialog-content">
    <div class="">
        <div class="mb-2 font-medium">Enter Note</div>
        <textarea rows="5" cols="30"
        class="w-full "
        pTextarea [(ngModel)]="noteValue"></textarea>
    </div>
    <div class="flex justify-end  mt-4">
        <p-button
            [label]="isUpdate ? 'Update' : 'Save'"
            icon="pi pi-save"
            [loading]="loading"
            [disabled]="!noteValue || loading"
            class="flex justify-end"
            (click)="handleSaveNote()"
        ></p-button>
    </div>
</div>